'use client';

import { c as _c } from "react/compiler-runtime";
import { Icon } from '@repo/ui';
import { TVL } from '@repo/ui/icons';
import { type CSSProperties, memo } from 'react';
type TextVariant = 'default' | 'small';
export interface PositionHistoryPlaceholderProps {
  height?: CSSProperties['height'];
  variant?: TextVariant;
}
const TypoClassByVariant: Record<TextVariant, string> = {
  default: 'text-xs',
  small: 'text-2xs'
};
const MessageByVariant: Record<TextVariant, string> = {
  small: 'Temporarily unavailable.',
  default: 'Position History is temporarily unavailable.'
};
const PositionHistoryPlaceholder = t0 => {
  const $ = _c(9);
  const {
    height,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const typoClass = TypoClassByVariant[variant];
  const message = MessageByVariant[variant];
  const t2 = height || "391px";
  let t3;
  if ($[0] !== t2) {
    t3 = {
      height: t2
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icon className="text-foreground" icon={<TVL />} />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== message || $[4] !== typoClass) {
    t5 = <span className={typoClass}>{message}</span>;
    $[3] = message;
    $[4] = typoClass;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t5) {
    t6 = <div className="gap-xs p-md border-border flex w-full flex-col items-center justify-center rounded-[20px] border-[0.5px] text-center" style={t3}>{t4}{t5}</div>;
    $[6] = t3;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
export default memo(PositionHistoryPlaceholder);